import React, {Component} from 'react';
import * as firebase from 'firebase';
import queryString from 'query-string';
import { keyBy } from 'lodash';
import './App.css';
import Login from './Login/Login';
import RequestTable from './RequestTable/RequestTable';
import lenderLogos from './lenderLogos';

const logosById = {};

lenderLogos.forEach((l) => {
  logosById[l.lenderGuid] = l.lenderLogo;
});

const parsed = queryString.parse(window.location.search);

let db = 'test-stream-d70d8';

if (parsed.db) {
  db = parsed.db;
}

firebase.initializeApp({
  apiKey: "AIzaSyC7aW7CxEabFUFoca8Qq6iRPxdnJ9t6Q5Q",
  authDomain: "test-stream-d70d8.firebaseapp.com",
  databaseURL: "https://test-stream-d70d8.firebaseio.com",
});

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: false
    };

    // auth/user-not-found
    // auth/wrong-password

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({
          loggedIn: true
        })
      } else {
        this.setState({
          loggedIn: false
        })
      }
    });
  }

  handleLogoutClick() {
    firebase.auth().signOut();
  }

  render() {
    let content = <Login firebase={firebase} />;

    if (this.state.loggedIn) {
      content = <RequestTable
        firebase={firebase}
        db={db}
        logosById={logosById}
      />
    }

    return (
        <div className="App">
          {content}
          <div className="logout">
            <div className="logoutButton" onClick={this.handleLogoutClick}>Logout</div>
          </div>
        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js